import styled from '@emotion/styled';

export const VideoContainer = styled.div`
  position: relative;
  height: 500px;
`;
